/*
 * Constants for Authorization
 */

/**
 * Scopes for ACH
 */
class ACHScopes {
  prefix = "ach";

  public read = `${this.prefix}:read`;
  public write = `${this.prefix}:write`;
}
/**
 * Scopes for agents
 */
class AgentScopes {
  prefix = "agents";

  public readClientSpecific: string = `${this.prefix}:read:client`;
  // public readAll: string = `${this.prefix}:read:all`;
}

/**
 * Scopes for client
 */
class ClientScopes {
  prefix = "clients";

  public readClientSpecific = `${this.prefix}:read:client`;
}

class ConversationsGatewayScopes {
  prefix = "conversations-gateway";
  public read = `${this.prefix}:read`;
  public write = `${this.prefix}:write`;
}

/**
 * Scopes for payment center
 */
class PaymentCenterScopes {
  prefix = "payment-center";

  public read = `${this.prefix}:read`;
  public write = `${this.prefix}:write`;
  public payByText = `${this.prefix}:text-to-pay`;

  public deletePaymentMethod = `${this.prefix}:payment-methods:delete`;
}

/**
 * Scopes for payment router
 */
class PaymentRouterScopes {
  prefix = "payment-router";

  public read = `${this.prefix}:read`;
  public write = `${this.prefix}:write`;
}

class ScheduledPaymentScopes {
  prefix = "scheduled-payments";

  public read = `${this.prefix}:read:user`;
  public write = `${this.prefix}:write:user`;
}

/**
 * Scopes for users
 */
class UserScopes {
  prefix = "users";

  public readClientSpecific = `${this.prefix}:read:client`;

  public writeUser = `${this.prefix}:write`;
}

/**
 * Organized hash of all scopes.
 */
class AuthorizationScopes {
  /**
   * ACH service scopes
   */
  public ach = new ACHScopes();
  /**
   * Agent service scopes
   */
  public agents = new AgentScopes();
  /**
   * Client service scopes
   */
  public clients = new ClientScopes();
  /**
   * Conversations gateway service scopes
   */
  public conversations = new ConversationsGatewayScopes();
  /**
   * Payment-center service scopes
   */
  public paymentCenter = new PaymentCenterScopes();
  /**
   * Payment-router service scopes
   */
  public paymentRouter = new PaymentRouterScopes();
  /**
   * Scheduled payments service scopes
   */
  public scheduledPayments = new ScheduledPaymentScopes();
  /**
   * User service scopes
   */
  public users = new UserScopes();
}

/**
 * List of all the scopes in the app.
 */
export const scopes: AuthorizationScopes = new AuthorizationScopes();

/**
 * List of all default scopes
 */
export const defaultScopes = [
  "openid",
  "profile",
  "email",
  scopes.ach.read,
  scopes.ach.write,
  scopes.conversations.read,
  scopes.conversations.write,
  scopes.paymentCenter.read,
  scopes.paymentCenter.write,
  scopes.scheduledPayments.read,
  scopes.scheduledPayments.write,
];

/**
 * The default scope used for requesting the access token from Auth0.
 */
export const defaultScope = defaultScopes.join(" ");
